import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import Block from "./Block";
import Image from "../image/Image";
var _attributes = /*#__PURE__*/new WeakMap();
export default class SingleImageBlock extends Block {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [SingleImageBlock.title_attribute_name]: null,
      [SingleImageBlock.image_attribute_name]: Image,
      [SingleImageBlock.image_max_width_attribute_name]: 700,
      [SingleImageBlock.image_border_visibility_attribute_name]: false
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getTitleAttributeName() {
    return this.title_attribute_name;
  }
  static getImageAttributeName() {
    return this.image_attribute_name;
  }
  static getImageMaxWidthAttributeName() {
    return this.image_max_width_attribute_name;
  }
  static getImageBorderVisibilityAttributeName() {
    return this.image_border_visibility_attribute_name;
  }
}
_defineProperty(SingleImageBlock, "BLOCK_TITLE", 'components.single_image_block.text');
_defineProperty(SingleImageBlock, "NAME", 'single_image_block');
_defineProperty(SingleImageBlock, "title_attribute_name", 'title');
_defineProperty(SingleImageBlock, "image_attribute_name", 'image');
_defineProperty(SingleImageBlock, "image_max_width_attribute_name", 'image_max_width');
_defineProperty(SingleImageBlock, "image_border_visibility_attribute_name", 'image_border_visibility');